<template>
  <div
    ref="flashcard-view-container"
    class="grouping-show-view-component"
  >
    <loading v-if="loading" />
    <template v-if="quizGrouping">
      <groupings-quiz-view
        :asset-association="assetAssociation"
        :breadcrumbs="breadcrumbs"
        :category="category"
        :grouping="grouping"
      />
    </template>
  </div>
</template>

<script>
import GroupingsQuizView from '@/views/groupings/types/quiz';
import Loading from '@/components/singletons/loading';

import GlobalMixin from '@/mixins/global';
import { rateLimitingEnabled } from '@/utils';

export default {
  name: 'GroupingsShowView',
  components: {GroupingsQuizView, Loading},
  mixins: [GlobalMixin],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    assetAssociation() {
      if (this.$route.params.assetAssociationId) {
        return this.grouping?.assetAssociations.find(aa => aa.id === Number(this.$route.params.assetAssociationId));
      }
    },
    breadcrumbs() {
      let crumbs = [];
      if (this.category) {
        crumbs.push({
          name: this.category.name,
          route: {
            name: 'groupings#index',
            params: {
              categoryId: this.category.id,
            },
            query: this.currentQuery,
          },
        });
      }
      crumbs.push({ name: this.grouping.name });
      return crumbs;
    },
    category() {
      if (this.$route.params.categoryId && this.$route.params.categoryId !== 'all') {
        return this.$store.getters['categories/categories'][this.$route.params.categoryId];
      }
    },
    grouping() {
      if (this.$route.params.groupingId) {
        return this.$store.getters['groupings/all'][this.$route.params.groupingId];
      } else if (this.currentResource?.resourceId) {
        return this.$store.getters['groupings/all'][this.currentResource.resourceId];
      }
    },
    quizGrouping() {
      return this.grouping?.groupingType === 'Quiz';
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params?.categoryId) {
      next({ ...to, params: { ...to.params, categoryId: 'all' } });
    } else {
      next();
    }
  },
  created() {
    this.$store.dispatch('flashcardStates/fetchStates', ['flashcards']);
  },
  mounted() {
    if (this.grouping) {
      const flashcardIds = this.grouping.flashcardAssociations?.map(aa => aa.assetBId);
      if (flashcardIds.length > 0) {
        const params = {
          ids: flashcardIds,
          rateLimited: rateLimitingEnabled({
            store: this.$store,
            apptimize: this.$apptimize,
            analytics: this.$analytics,
          }),
        };
        this.$store.dispatch('flashcards/fetchFlashcards', params).then(_ => {
          this.loading = false;
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
